<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;" v-loading.fullscreen.lock="confirmLoading">
    <div style="padding:0px;width:100%;">
      <div style="width:260px;float: left;" class="whiteBox searchbox">
        <h4><i class="el-icon-d-arrow-right"></i> 筛选条件</h4>
        <div class="filter-container search-box">
          <el-form label-position="top" label-width="80px">
            <el-form-item label="搜索">
              <el-input size="mini" style="width:180px;top:2px;" placeholder="姓名/手机号/微信号"
                v-model="searchQuery.key" clearable></el-input>
            </el-form-item>
            <el-form-item label="线上渠道">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.onlineSources">
                <el-option v-for="item in importSourceOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="系统入口">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.entry">
                <el-option
                  v-for="item in systemEntrances"
                  :key="item.dataValue"
                  :label="item.dataDisplay"
                  :value="item.dataValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-input size="mini" style="width:180px;top:2px;" placeholder="线索来源"
                v-model="searchQuery.clueSource" clearable></el-input>
            </el-form-item>
            <el-form-item label="线索二级来源">
              <el-input size="mini" style="width:180px;top:2px;" placeholder="线索二级来源"
                v-model="searchQuery.secondSource" clearable></el-input>
            </el-form-item>
            <el-form-item label="线索类别">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.clueLevel">
                <el-option :value="0" label="全部">全部</el-option>
                <el-option :value="1" label="一类">一类</el-option>
                <el-option :value="2" label="二类">二类</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线索时间">
              <el-date-picker v-model="searchQuery.dateRange" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="线索清洗开始时间" v-if="filterType === 6">
              <el-date-picker style="margin-bottom: 5px;" v-model="searchQuery.clearDateRange" type="daterange" size="mini" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
                value-format="yyyy-MM-dd"></el-date-picker>
              <el-select size="mini" placeholder="请选择时间段" clearable style="width:180px;" v-model="searchQuery.clearTime">
                <el-option label="09:00:00-17:59:59" value="9-17"></el-option>
                <el-option label="10:00:00-17:59:59" value="10-17"></el-option>
                <el-option label="18:00:00-19:59:59" value="18-19"></el-option>
              </el-select>

            </el-form-item>
            <el-form-item label="客户经理" v-if="members.length > 1">
              <el-select size="mini" style="width:180px;" multiple v-model="searchQuery.member">
                <el-option v-for="item in members" :key="item.memberId" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否微信线索" v-if="filterType != 5">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.isWechatClue">
                <el-option v-for="[value, label] in isWechatClueMap" :key="value" :value="value" :label="label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否异地购车">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.isRemote">
                <el-option v-for="item in isRemoteList" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="displayDccSearch && filterType !== 8" label="是否DCC线索">
              <el-select size="mini" style="width:180px;" v-model="searchQuery.isDccClue">
                <el-option v-for="item in isDccClueList" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button size="small" icon="el-icon-search" class="filter-item" @click="retrieveTables">筛选</el-button>
            <el-button size="small" icon="el-icon-refresh" class="filter-item" @click="reset">重置</el-button>
            <el-button size="small" icon="el-icon-download" class="filter-item" @click="doExport"
              v-if="isShowExport">导出</el-button>
          </div>
        </div>
      </div>
      <div style="margin-left: 320px; overflow:auto;margin-right:20px;padding:0px 20px;">
        <h1 class="page_title">线索处理</h1>
        <div class="filter-container">
          <div class="filter-tab">
            <el-radio-group size="small" v-model="filterType" @change="retrieveTables1">
              <el-radio-button :label="1">待清洗</el-radio-button>
              <el-radio-button :label="2" v-if="allowOnlineAssign">待分配</el-radio-button>
              <el-radio-button :label="3">有效</el-radio-button>
              <el-radio-button :label="7" v-if="!isNoShowFollowing">跟进中</el-radio-button>
              <el-radio-button :label="4">无效</el-radio-button>
              <el-radio-button :label="5">未接通</el-radio-button>
              <el-radio-button :label="8">高意向</el-radio-button>
              <el-radio-button :label="6">全部</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="dcc-tip" v-if="!dccTip[dealer.userId] && isShowTip">
          部分线索在DCC线索管理平台清洗，未展示在列表中。
          <!-- <span class="click_link" style="margin-left: 5px;cursor: pointer;" @click="viewDccClueAll">查看全部</span> -->
          <i class="el-icon-close" @click="closeDccTip"></i>
        </div>
        <el-table :key="filterType" :data="tableRecords" stripe v-loading="listLoading" :row-class-name="tableRowClassName">
          <el-table-column align="left" label="时间" width="160" key="createdDate">
            <template slot-scope="scope">{{ scope.row.createdDate }}</template>
          </el-table-column>
          <el-table-column align="left" label="姓名" min-width="160" key="name">
            <template slot-scope="scope">
              <span :class="{ click_link: (filterType !== 8 && !(scope.row.isDccClue && !isNoShowFollowing)) || (filterType === 8 && scope.row.customerId) }" @click="(filterType !== 8 && scope.row.isDccClue && !isNoShowFollowing) || (filterType === 8 && !scope.row.customerId) ? '' : toDetailPage(scope.row)">
                {{ `${scope.row.name}${ scope.row.phone ? ` - ` : ''}`  }}
                <Desensitize
                  v-if="scope.row.phone"
                  :text="scope.row.phone"
                  :userType="3"
                  :clearText="true"
                  :queryKey="scope.row.clueId"
                  :key="scope.row.clueId"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left" v-if="filterType == 6" label="完成任务" width="120" key="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 2">{{
                scope.row.type == 2 ? "清洗完成" : "分配完成"
              }}</span>
              <span v-if="scope.row.status == 1">{{
                scope.row.type == 2 ? "待清洗" : "待分配"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" v-if="filterType == 6" label="结果" width="120" key="clearStatus">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 2 && scope.row.type == 1">有效</span>
              <span v-if="scope.row.status == 2 && scope.row.type != 1">{{
                scope.row.clearStatus | clearStatusFitter
              }}</span>
              <span v-if="scope.row.status == 1">{{
                scope.row.type == 2 ? "" : "有效"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="是否DCC线索" width="150" key="isDccClue" v-if="filterType !== 8">
            <template slot-scope="scope">{{ isDccClueMap.get(scope.row.isDccClue) }}</template>
          </el-table-column>
          <el-table-column align="left" label="处理人员" width="120" v-if="filterType != 2" key="ownerName">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="渠道" width="120" key="sourceName">
            <template slot-scope="scope">{{ scope.row.sourceName }}</template>
          </el-table-column>
          <el-table-column align="left" label="系统入口" width="120" key="entry">
            <template slot-scope="scope">{{ transformatLabel(scope.row.entry, systemEntrances) }}</template>
          </el-table-column>
          <el-table-column align="left" label="线索来源" width="120" key="clueSource">
            <template slot-scope="scope">{{ scope.row.clueSource }}</template>
          </el-table-column>
          <el-table-column align="left" label="线索二级来源" width="120" key="secondSource" prop="secondSource">
            <template slot-scope="scope">{{ scope.row.secondSource }}</template>
          </el-table-column>
          <el-table-column align="left" label="类型" width="120" key="clueLevel">
            <template slot-scope="scope">{{
              scope.row.clueLevel == 1 ? "一类线索" : "二类线索"
            }}</template>
          </el-table-column>
          <el-table-column align="left" v-if="filterType == 6" label="清洗时长" width="120" key="clearSeconds">
            <template slot-scope="scope">
              <span>{{ MillisecondToDate(scope.row.clearSeconds) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" v-if="filterType == 6" label="跟进时长" width="120" key="followSeconds">
            <template slot-scope="scope">
              <span>{{ MillisecondToDate(scope.row.followSeconds) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="异常清洗" width="120" key="dialMessage" v-if="filterType !== 8">
            <template slot-scope="scope">{{ scope.row.dialMessage || '' }}</template>
          </el-table-column>
          <el-table-column align="left" label="微信号" width="120" key="wechatId">
            <template slot-scope="scope">{{ scope.row.wechatId }}</template>
          </el-table-column>
          <el-table-column align="left" label="是否微信线索" width="120" key="isWechatClue">
            <template slot-scope="scope">{{ scope.row.isWechatClue ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column align="left" label="线索清洗开始时间" width="140" key="clearStartTime" v-if="filterType === 6">
            <template slot-scope="scope">{{ scope.row.clearStartTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
            layout="total, sizes, prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="线索详情" :visible.sync="detailDialog" width="920px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="detailForm" label-position="right" :model="detailForm" :rules="detailFormRules" label-width="100px">
        <div class="pure-g">
          <!-- 线索详情基本信息 -->
          <div class="pure-u-1-2">
            <el-form-item class="form_item" label="姓名">{{
              detailForm.name
            }}</el-form-item>
            <el-form-item class="form_item" label="手机号">
              <el-input v-if="isWxClue" v-model="detailForm.phone" size="mini" style="width: 200px"></el-input>
              <span v-else>{{ detailForm.phone }}</span>
            </el-form-item>
            <el-form-item class="form_item" label="微信号">{{
              detailForm.wechatId
            }}</el-form-item>
            <el-form-item class="form_item" label="意向车系">{{
              detailForm.mappingSpecId == 0 ? detailForm.seriesName: detailForm.mappingSeriesName
            }}</el-form-item>
            <el-form-item class="form_item" label="归属地">{{
              detailForm.province + "/" + detailForm.city
            }}</el-form-item>
            <el-form-item class="form_item" label="购车地区">{{ detailForm.buyCarAddressText||'' }}</el-form-item>
            <el-form-item class="form_item" label="是否异地购车">{{ detailForm.isRemote|formatRemote }}</el-form-item>
            <el-form-item v-if="displayDccSearch && detailForm.isDccClue" class="form_item" label="是否DCC线索">{{ isDccClueMap.get(detailForm.isDccClue)  }}</el-form-item>
            <el-form-item class="form_item" label="来源平台">{{ detailForm.sourceName }}
              <a :href="detailForm.zhwxUrl" style="margin-left:8px;color: #409EFF;" target="_blank"
                rel="noopener noreferrer" v-show="detailForm.zhwxUrl">智慧网销</a>
            </el-form-item>
            <el-form-item class="form_item" label="线索创建时间">{{
              detailForm.createTime
            }}</el-form-item>
            <el-form-item class="form_item" label="线索类别">{{
              detailForm.clueLevel == 1 ? "一类" : "二类"
            }}</el-form-item>
            <el-form-item class="form_item" label="参与活动" v-if="detailForm.activityDesc">{{ detailForm.activityDesc }}</el-form-item>
            <el-form-item class="form_item" label="营销备注" v-if="detailForm.marketingRemark">{{ detailForm.marketingRemark }}</el-form-item>
            <el-form-item class="form_item" label="线上已付金额" v-if="detailForm.paymentMoney > 0">{{ detailForm.paymentMoney /
              100 }}元</el-form-item>
          </div>
          <!-- 操作记录 -->
          <div class="pure-u-1-2" style="height:200px;overflow-y:auto;">
            <div class="pure-g" v-for="(item, index) in timelines" :key="item.id">
              <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
                {{ item.createdAt | parseTime("{y}-{m}-{d} {h}:{i}") }}
              </div>
              <div class="pure-u-1-1 el-form-item__content" style="padding-left:20px;">
                <p style="line-height:20px;">
                  处理人员: {{ item.handleOwnerName }}
                </p>
                <p style="line-height:20px;">处理结果: {{ item.result }}</p>
                <p style="line-height:20px;" v-if="item.followOwnerName != ''">
                  跟进人员: {{ item.followOwnerName }}
                </p>
                <p style="line-height:20px;" v-if="item.invalidReasonText != ''">
                  无效原因: {{ item.invalidReasonText }}
                </p>
                <p style="display: flex;line-height:20px;" v-if="item.remark != ''">
                  <span style="width: 30px">备注: </span>
                  <!-- {{ item.remark }} -->
                  <span v-html="item.remark.replaceAll('\n', '<br/>')"></span>
                </p>
                <p style="display: flex;line-height:20px;" v-if="item.remarkPic && item.remarkPic.length > 0">
                  <span style="width: 96px">客户微信截图: </span>
                  <span>
                    <Upload v-model="item.remarkPic" disabled isMini >
                    </Upload>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- // 1代表dcc线索，0代表不是dcc线索(智蛛线索) -->
        <template v-if="detailForm.isDccClue ==0">
          <!-- 1：待清洗 4:无效  12：未接通 -->
          <!-- 第一个内部表单 case1  1：待清洗 12：未接通线索清洗 --BDC清洗，BDC分配/主管分配 -->
          <div v-if="(formViewOnly == false && detailForm.status == 1 && !isAutoClear) || (formViewOnly == false && detailForm.status == 12 && !isAutoClear)">
            <div class="line-separator" style="margin-top:10px;"></div>
            <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="100px">
              <div class="pure-g">
                <div class="pure-u-1-1" style="padding-bottom:12px;">
                  <el-form-item class="form_item" label="线索状态">
                    <el-radio-group v-model="form.type" size="mini">
                      <el-radio-button :label="1">有效</el-radio-button>
                      <el-radio-button :label="2">无效</el-radio-button>
                      <el-radio-button v-if="!isWxClue" :label="3">未接通</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="购车类型">
                    <el-select size="mini" style="width:160px;" v-model="form.businessType">
                      <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                        :value="item.dataValue"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item form_item--buyAddress" prop="buyCarAddress" label="购车地区">
                    <div style="display:flex;">
                      <el-popover
                        placement="top-start"
                        title=""
                        width="210"
                        trigger="hover"
                        content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                        <i slot="reference" style="margin-left:5px;margin-right: 5px;" class="el-icon-question"></i>
                      </el-popover>
                      <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince" v-model="form.buyProvince">
                        <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity" v-model="form.buyCity">
                          <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="form.buyArea">
                          <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1 && form.businessType == 4">
                  <el-form-item class="form_item" label="采购数量">
                    <el-input-number size="mini" v-model="form.buyCount" :min="0" :max="10000"></el-input-number>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="意向车系">
                    <el-select size="mini" style="width:160px;" placeholder="选择意向车系" v-model="form.specIds" multiple
                      :multiple-limit="5" filterable>
                      <el-option v-for="(item,index) in seriesOptions" :key="index" :label="item.name"
                        :value="item.specId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1 && allowAssign">
                  <el-form-item class="form_item" label="客户经理">
                    <el-select size="mini" style="width:160px;" placeholder="选择客户经理" v-model="form.memberId" filterable>
                      <el-option v-for="item in assignMembers" :key="item.memberId"
                        :label="item.userName + '(' + item.clueCount + ')'" :value="item.memberId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 2">
                  <el-form-item class="form_item" label="无效原因">
                    <el-radio-group v-model="form.invalidReason" size="mini">
                      <el-radio-button v-for="item in invalidReasons" :key="item.dataValue" :label="item.dataValue">{{
                        item.dataDisplay }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <!-- <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 2 && form.invalidReason === 99">
                  <el-form-item class="form_item" label="备注" :prop="form.invalidReason === 99 ? 'remark': ''">
                    <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                      v-model="form.remark"></el-input>
                  </el-form-item>
                </div> -->

                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 2 && form.invalidReason == 15">
                  <el-form-item class="form_item" label="客户意向购车城市" prop="home">
                    <el-cascader v-model="form.home" :options="failCities" :props="{ value: 'label' }"
                      size="small"></el-cascader>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-show="(form.type !== 2 || form.invalidReason == 99) &&
                  form.type != 3
                  ">
                  <el-form-item class="form_item" label="备注" :prop="(form.type !== 2 || form.invalidReason == 99) &&
                  form.type != 3 ? 'remark' : ''">
                    <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                      v-model="form.remark"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1">
                  <el-form-item v-if="isWxClue && form.type !== 3" class="form_item" :label="`请上传${form.type === 1 ? '客户' : '无效'}微信截图`" :prop="isWxClue && form.type !== 3 ? 'wxPic' : ''">
                    <!-- v-if="detailDialog" -->
                    <Upload v-model="form.wxPic"></Upload>
                  </el-form-item>
                </div>

              </div>
            </el-form>
          </div>

          <!-- 1：待清洗 4:无效  12：未接通 -->
          <!-- 第二个内部表单 4:无效线索清洗 --BDC清洗，BDC分配/主管分配 --> 
          <div v-if="formViewOnly == false && detailForm.status == 4 && !isAutoClear">
            <div class="line-separator" style="margin-top:10px;"></div>
            <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="100px">
              <div class="pure-g">
                <div class="pure-u-1-1" style="padding-bottom:12px;">
                  <el-form-item class="form_item" label="线索状态">
                    <el-radio-group v-model="form.type" size="mini">
                      <el-radio-button :label="1">有效</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="购车类型">
                    <el-select size="mini" style="width:160px;" v-model="form.businessType">
                      <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                        :value="item.dataValue"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item form_item--buyAddress" prop="buyCarAddress" label="购车地区">
                    <div style="display:flex;">
                      <el-popover
                        placement="top-start"
                        title=""
                        width="210"
                        trigger="hover"
                        content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                        <i slot="reference" style="margin-left:5px;margin-right: 5px;" class="el-icon-question"></i>
                      </el-popover>
                      <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince" v-model="form.buyProvince">
                        <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity" v-model="form.buyCity">
                          <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="form.buyArea">
                          <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1 && form.businessType == 4">
                  <el-form-item class="form_item" label="采购数量">
                    <el-input-number size="mini" v-model="form.buyCount" :min="0" :max="10000"></el-input-number>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="意向车系">
                    <el-select size="mini" style="width:160px;" placeholder="选择意向车系" v-model="form.specIds" filterable
                      multiple :multiple-limit="5">
                      <el-option v-for="(item, index) in seriesOptions" :key="index" :label="item.name"
                        :value="item.specId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1 && allowAssign">
                  <el-form-item class="form_item" label="客户经理">
                    <el-select size="mini" style="width:160px;" placeholder="选择客户经理" v-model="form.memberId" filterable>
                      <el-option v-for="item in assignMembers" :key="item.memberId"
                        :label="item.userName + '(' + item.clueCount + ')'" :value="item.memberId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 1 || form.type == 2">
                  <el-form-item class="form_item" label="备注" prop="remark">
                    <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                      v-model="form.remark"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1">
                  <el-form-item v-if="isWxClue && form.type !== 3" class="form_item" :label="`请上传${form.type === 1 ? '客户' : '无效'}微信截图`" :prop="isWxClue && form.type !== 3 ? 'wxPic' : ''">
                    <Upload v-model="form.wxPic"></Upload>
                  </el-form-item>                  
                </div>
              </div>
            </el-form>
          </div>

          <!-- 1：待清洗 4:无效  12：未接通 -->
          <!-- 第三个内部表单  case3 （非管理员）（客户经理角色）公司策略：无BDC清洗，自动分配 --> 
          <div v-if="(formViewOnly == false && detailForm.status == 1 && isAutoClear) || (formViewOnly == false && detailForm.status == 12 && isAutoClear) ||(formViewOnly == false && detailForm.status == 4 && isAutoClear)">
            <div class="line-separator" style="margin-top:10px;"></div>
            <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="100px">
              <div class="pure-g">
                <div class="pure-u-1-1" style="padding-bottom:12px;">
                  <el-form-item class="form_item" label="线索状态">
                    <el-radio-group v-model="form.type" size="mini">
                      <el-radio-button :label="1">有效</el-radio-button>
                      <el-radio-button :label="2" v-show="detailForm.status != 4">无效</el-radio-button>
                      <el-radio-button :label="3" v-show="detailForm.status != 4 && !isWxClue">未接通</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="add-title" v-if="form.type == 1">客户信息</div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="性别" prop="gender">
                    <el-radio-group v-model="form.gender" size="mini">
                      <el-radio-button :label="1">先生</el-radio-button>
                      <el-radio-button :label="2">女士</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="上牌类型">
                    <el-radio-group v-model="form.memberType" size="mini">
                      <el-radio-button :label="1">个人</el-radio-button>
                      <el-radio-button :label="2">企业</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="form.type == 1 && form.memberType == 2">
                  <el-form-item class="form_item" label="企业名称" prop="companyName">
                    <el-input size="mini" style="width: 160px;" v-model="form.companyName"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="(form.type == 1 && form.fromSource == 98) ||
                  (form.type == 1 && form.fromSource == 99)
                  ">
                  <el-form-item class="form_item" :label="form.fromSource == 98 ? '网络来源' : '其他来源'">
                    <el-input size="mini" style="width: 160px;" v-model="form.otherSource"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="其他联系号码">
                    <el-input size="mini" style="width: 160px;" v-model="form.secondardPhone"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="更多">
                    <el-switch v-model="value1"></el-switch>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1 && form.type == 1">
                  <el-form-item class="form_item" label="所在地">
                    <el-cascader v-model="home" :options="homeOptions" :props="props" size="small"></el-cascader>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1 && form.type == 1">
                  <el-form-item class="form_item" label="联系地址">
                    <el-input size="mini" style="width: 200px;" v-model="form.addition.address"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1 && form.type == 1">
                  <el-form-item class="form_item" label="身份证">
                    <el-input size="mini" style="width: 160px;" v-model="form.addition.idNo"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1 && form.type == 1">
                  <el-form-item class="form_item" label="生日">
                    <el-date-picker size="mini" style="width:160px;" v-model="form.addition.birthday" :clearable="false"
                      type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1 && form.type == 1">
                  <el-form-item class="form_item" label="QQ">
                    <el-input size="mini" style="width: 160px;" v-model="form.addition.qq"></el-input>
                  </el-form-item>
                </div>
                <div class="add-title" v-if="form.type == 1">购车意向</div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="购车类型">
                    <el-select size="mini" style="width:160px;" v-model="form.businessType">
                      <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                        :value="item.dataValue"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item form_item--buyAddress" prop="buyCarAddress" label="购车地区">
                    <div style="display:flex;">
                      <el-popover
                        placement="top-start"
                        title=""
                        width="210"
                        trigger="hover"
                        content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                        <i slot="reference" style="margin-left:5px;margin-right: 5px;" class="el-icon-question"></i>
                      </el-popover>
                      <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince" v-model="form.buyProvince">
                        <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity" v-model="form.buyCity">
                          <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="form.buyArea">
                          <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1 && form.businessType == 4">
                  <el-form-item class="form_item" label="采购数量">
                    <el-input-number size="mini" v-model="form.buyCount" :min="0" :max="10000"></el-input-number>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="意向车系" prop="specIds">
                    <el-select size="mini" style="width:220px;" placeholder="选择意向车系" v-model="form.specIds" multiple
                      :multiple-limit="5" filterable>
                      <el-option v-for="(item,index) in seriesOptions" :key="index" :label="item.name"
                        :value="item.specId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="意向竞品">
                    <el-select size="mini" style="width:220px;" placeholder="选择意向竞品" v-model="form.competitionSerieses"
                      multiple :multiple-limit="5" filterable>
                      <el-option v-for="(item, index) in competitionSeriesesOptions" :key="index"
                        :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="客户级别">
                    <el-select size="mini" style="width:160px;" v-model="form.level" @change="changeLevel">
                      <el-option v-for="item in followLevelOptions" :key="item.dataName" :label="item.dataDisplay"
                        :value="item.dataName"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="购车预算">
                    <el-select size="mini" style="width:160px;" v-model="form.budget">
                      <el-option v-for="item in budgetOptions" :key="item.dataValue" :label="item.dataDisplay"
                        :value="item.dataValue"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="预计购车时间">
                    <el-date-picker size="mini" style="width:160px;" v-model="form.buycarDate" :clearable="false"
                      type="date" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                  <div style="font-size: 13px;display:inline-block;height: 100%;line-height: 28px;">
                    之前
                  </div>
                </div>
                <div class="add-title" v-if="form.type == 1">下次跟进计划</div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="下次跟进">
                    <el-radio-group v-model="form.nextActivityType" size="mini">
                      <el-radio-button v-for="item in activityNextFollowTypes" :key="item.dataValue"
                        :label="item.dataValue">{{ item.dataDisplay }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="form.type == 1">
                  <el-form-item class="form_item" label="跟进日期">
                    <el-date-picker size="mini" style="width:160px;" v-model="form.nextDate" :clearable="false" type="date"
                      placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.nextActivityType == 3">
                  <el-form-item class="form_item" label="试驾车系">
                    <el-select size="mini" style="width: 160px;" placeholder="选择试驾车系" filterable
                      v-model="form.nextTestSpecId">
                      <el-option v-for="item in seriesOptions" :key="item.specId" :label="item.name"
                        :value="item.specId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 2">
                  <el-form-item class="form_item" label="无效原因">
                    <el-radio-group v-model="form.invalidReason" size="mini">
                      <el-radio-button v-for="item in invalidReasons" :key="item.dataValue" :label="item.dataValue">{{
                        item.dataDisplay }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-show="form.type !== 2 || form.invalidReason == 99">
                  <el-form-item class="form_item" label="备注">
                    <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                      v-model="form.remark"></el-input>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1">
                  <el-form-item v-if="isWxClue && form.type !== 3" class="form_item" :label="`请上传${form.type === 1 ? '客户' : '无效'}微信截图`" :prop="isWxClue && form.type !== 3 ? 'wxPic' : ''">
                    <Upload v-model="form.wxPic"></Upload>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </template>

          <!-- 5：待分配 -->
          <div v-if="detailForm.status == 5">
            <div class="line-separator" style="margin-top:10px;"></div>
            <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="80px">
              <div class="pure-g">
                <div class="pure-u-1-2" style="padding-bottom:12px;">
                  <el-form-item class="form_item" label="客户经理" prop="memberId">
                    <el-select size="mini" style="width:160px;" placeholder="选择客户经理" v-model="form.memberId" filterable>
                      <el-option v-for="item in assignMembers" :key="item.memberId"
                        :label="item.userName + '(' + item.clueCount + ')'" :value="item.memberId"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="form.type == 1 || form.type == 2">
                  <el-form-item class="form_item" label="备注" prop="remark">
                    <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                      v-model="form.remark"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doConfirm" type="text" v-if="formViewOnly == false">确定</el-button>
        <el-button @click="doCancel" type="text">{{
          formViewOnly ? "关闭" : "取消"
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="智慧网销" :visible.sync="introDialog" width="850px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="pure-g">
        <div class="pure-u-1-2">
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">购车指数</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.buyCarIndex + "%" }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">预算评估</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.budget }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">置换概率</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.replaceProbability * 100 + "%" }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">贷款概率</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.loanProbability * 100 + "%" }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">配置偏好</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.configurePrefer }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">上网时段偏好</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.onlinePrefer }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">常住地</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.customerCity }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">购车用途</div>
            <div class="pure-u-2-3 el-form-item__content">
              {{ detailForm.purpose }}
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">询价历史</div>
            <div class="pure-u-2-3 el-form-item__content">
              <p v-for="item in JSON.parse(detailForm.historySpec)" :key="item.specid">
                {{ item.specname }}
              </p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">关注车系</div>
            <div class="pure-u-2-3 el-form-item__content">
              <span v-for="item in JSON.parse(detailForm.attentionSeries)" :key="item.seriesName">{{ item.seriesName
              }}&nbsp;</span>
            </div>
          </div>
        </div>
        <div class="pure-u-1-2">
          <div class="pure-g" style="padding-left:20px;">
            <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
              开场白
            </div>
            <div class="pure-u-1-1 el-form-item__content">
              {{ detailForm.openingRemarks }}
            </div>
            <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
              车型介绍
            </div>
            <div class="pure-u-1-1 el-form-item__content">
              {{ detailForm.specIntroduction }}
            </div>
            <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
              活动推荐
            </div>
            <div class="pure-u-1-1 el-form-item__content">
              {{ detailForm.activityRecommend }}
            </div>
            <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
              报价策略
            </div>
            <div class="pure-u-1-1 el-form-item__content">
              {{ detailForm.pricingStrategy }}
            </div>
            <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
              邀约到店
            </div>
            <div class="pure-u-1-1 el-form-item__content">
              {{ detailForm.inviteToShop }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="doRemark"  type="text">确定</el-button> -->
        <el-button @click="introDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="mergeVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span style="font-size: 18px; font-weight: 600; margin-bottom: 8px;">该客户已存在，是否需要合并至原客档？</span>
      <div>
        <div style="line-height: 30px; color: #409EFF">{{ mergeCustomerInfo.customerName }}  {{ mergeCustomerInfo.phone }}</div>
        <div style="line-height: 30px;">创建时间：{{ mergeCustomerInfo.createTime }}</div>
        <div style="line-height: 30px;">客户经理：{{ mergeCustomerInfo.ownerName }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleMerge(false)">否</el-button>
        <el-button type="primary" @click="handleMerge(true)">是</el-button>
      </span>
   </el-dialog>

  </div>
</template>

<script>
import Cookies from "js-cookie";
import { MillisecondToDate } from "../../filters/index";
import { 
  isRemoteMap, 
  isRemoteList,
  isDccClueMap,
  isDccClueList,
  isWechatClueMap
} from '@/assets/js/commonMap';
import { remarkValidator, mobileReg, getUrls } from '@/assets/js/util'
import { mapActions, mapGetters } from 'vuex'
import Upload from "@/components/common/Upload.vue";
import ImageUpload from '@/components/common/ImageUpload.vue';
import dayjs from 'dayjs';
import Desensitize from "@/components/Desensitize/Desensitize.vue";

const remoteMap = new Map([
  [0,'全部'],
  [1, '是'],
  [2, '否']
])

// 待清洗 + 未接通 + 无效
const activityTypeDCCList = [1, 5, 4]
// 待分配 + 有效
const activityTypeList = [2, 3]

var activity_verify_tasks_vm;
export default {
  components: {
    Upload,
    ImageUpload,
    Desensitize
  },
  data() {
    activity_verify_tasks_vm = this;
    const validateBuyCarAddress = (rule, value, callback) => {
      const [buyProvince, buyCity] = value
        if (!!buyProvince&&!!buyCity) {
            callback();
        } else {
            callback(new Error("请选择购车地区"));
        }
    }
    return {
      isRemoteMap, 
      isRemoteList,
      isDccClueMap,
      isDccClueList,
      isWechatClueMap,
      listLoading: false,
      clueInvalidReasons: [],
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      searchQuery: {
        key: "",
        onlineSources: [],
        entry: [],
        clueSource: '', // 线索来源
        secondSource: '', //线索二级来源
        clueLevel: 0,
        dateRange: null,
        clearDateRange: null,
        clearTime: "",
        member: [],
        isRemote: null,
        isWechatClue: 0, // 是否微信线索
        isDccClue: isDccClueList[0].value,
      },
      filterType: 1,

      members: [],
      levelOptions: [],
      businessTypeOptions: [],
      fromSourceOptions: [],
      importSourceOptions: [],
      followLevelOptions: [],
      carOptions: [],

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      tableRecords: [],

      detailDialog: false,
      // 线索详情基本信息
      detailForm: {
        historySpec: "{}",
        attentionSeries: "{}",
      },
      timelines: [],// 操作记录
      detailFormRules: {},

      introDialog: false,

      form: {
        buyCarAddress: [],//购车地区-省市区
        buyProvince: '',// 购车地区-省
        buyCity: '',// 购车地区-市
        buyArea: '',// 购车地区-区
        type: 1,
        businessType: 1,
        invalidReason: "",
        specIds: [],
        memberId: "",
        remark: "",
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        buycarDate: "",
        budget: 1,
        nextTestSpecId: "",
        addition: {
          province: "",
          city: "",
          address: "",
          idNo: "",
          birthday: "",
          qq: "",
        },
        home: [],
        wxPic: []
      },
      formRules: {
        buyCarAddress: [
            {
              // type: 'array',
              required: true,
              message: "请选择购车地区",
              trigger: "change",
              validator: validateBuyCarAddress,
            },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
        specIds: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        fromSource: [
          {
            required: true,
            message: "请选择客户来源",
            trigger: "blur",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        home: [
          {
            required: true,
            message: "请选择省市",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("备注", ...args)
            },
            trigger: "blur",
          },
        ],
        wxPic: [
          {
            type: "array",
            required: true,
            message: "请上传客户微信截图",
            trigger: "change",
          },
        ],
      },
      formViewOnly: false,
      seriesOptions: [],
      competitionSeriesesOptions: [],
      assignMembers: [],

      confirmLoading: false,
      datePickerOption: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      activityNextFollowTypes: [],
      budgetOptions: [],
      value1: false,
      home: [],
      homeOptions: [],
      props: {
        value: "city",
        label: "city",
        children: "cities",
      },
      allowAssign: this.$common.getLoginInfo().allowAssign,
      isAutoClear: this.$common.getLoginInfo().isAutoClear,
      allowOnlineAssign: this.$common.getLoginInfo().allowOnlineAssign,
      role: this.$common.getLoginInfo().role,
      failCities: [],//战败省份/城市
      provinces: [],// 省份
      buyCarCityList: [],// 购车地区-城市列表
      buyCarAreaList: [],// 购车地区-城市列表
      dealerProvince: '',// 门店所在省份
      dealerCity: '',// 门店所在市
      dealerArea: '',// 门店所在区
      displayDccSearch: true,// 是否展示dcc搜索
      systemEntrances: [], // 系统入口
      mergeVisible: false,
      mergeCustomerInfo: {}
    };
  },
  computed: {
    ...mapGetters('user', ['dccTip', 'profile']),
    isNoShowFollowing() {
      // 直营门店/社会经销商非DCC门店不展示 dealerType 1直营 2非直营  isDccDealer  0否 1是
      return this.profile.dealerType === 1 || this.profile.isDccDealer === 0
    },
    isShowTip() {
      // 直营门店展示 && 待分配/有效/全部
      return this.profile.dealerType === 1 && activityTypeDCCList.includes(this.filterType)
    },
    invalidReasons() {
      return this.detailForm.isWechatClue ?  this.clueInvalidReasons.filter(item => item.dataValue >= 99) : this.clueInvalidReasons.filter(item => item.dataValue <= 99);
    },
    isWxClue() {
      return this.detailForm.isWechatClue == 1 && (this.detailForm.status == 1 || this.detailForm.status == 4)
    },
    // 管理员 && 导出开关配置开启 && 配置导出角色包含当前用户角色
    isShowExport() {
      const baseInfo = this.$common.getBaseInfo();
      const { appClueDownloadSwitch = [], appClueDownloadRoles = [] } = baseInfo;
      return this.isAdmin && appClueDownloadSwitch && appClueDownloadSwitch[0]?.dataValue === 1 && appClueDownloadRoles && appClueDownloadRoles[0]?.dataName && appClueDownloadRoles[0]?.dataName.split(',').map(n=>Number(n)).includes(this.role)
    },
    // 高亮线索二级来源配置
    siteDescHighLights() {
      const baseInfo = this.$common.getBaseInfo();
      return baseInfo.siteDescHighLights|| []
    }
  },
  filters: {
    formatRemote(isRemote) {
      if (!isRemote) return ''
      return new Map(Array.from(isRemoteMap).slice(1,3)).get(isRemote)
    },
    levelDisplay(level) {
      for (var i = 0; i < activity_verify_tasks_vm.levelOptions.length; i++) {
        var o = activity_verify_tasks_vm.levelOptions[i];
        if (o.dataName == level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    activityTypeDisplay(type) {
      const displayMap = {
        1: "沟通",
        2: "到店",
        3: "试驾",
        4: "订车",
        5: "交车",
        6: "战败",
        7: "建档",
        8: "回访",
        10: "战败复活",
        21: "新线索分配",
        22: "新线索清洗",
        23: "战败审核",
      };
      return displayMap[type + ""];
    },
    clearStatusFitter(val) {
      var str = "";
      switch (Number(val)) {
        case 1:
          str = "有效";
          break;
        case 2:
          str = "无效";
          break;
        case 3:
          str = "未联系上";
          break;

        default:
          break;
      }
      return str;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path.startWith("/customer/detail/")) {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem("listFilters"));
          vm.searchQuery = listFilters.searchQuery;
          vm.filterType = listFilters.filterType;
          vm.total = listFilters.total;
          vm.listQuery = listFilters.listQuery;
        } catch (error) { 
          console.log(error)
        }
      }
      vm.getList();
    });
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    var loginInfo = this.$common.getLoginInfo();
    this.levelOptions = baseInfo.customerLevels;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.fromSourceOptions = baseInfo.customerFromSources;
    this.importSourceOptions = baseInfo.importSources;
    this.followLevelOptions = baseInfo.customerFollowLevels;
    this.activityNextFollowTypes = baseInfo.activityNextFollowTypes;
    this.systemEntrances = baseInfo.systemEntrances;
    if (loginInfo.cityPoolEnable) {
      this.clueInvalidReasons = baseInfo.clueInvalidReasons
    } else {
      this.clueInvalidReasons = baseInfo.clueInvalidReasons.filter(item => item.dataValue != 15);
    }
    this.budgetOptions = baseInfo.budgets;
    this.budgetOptions.forEach((item) => {
      item.dataDisplay = item.dataDisplay + "万元";
    });
    this.homeOptions = baseInfo.cities;
    this.homeOptions.forEach((item) => {
      item.city = item.province;
    });
    this.failCities = this.getProvinceOptions(baseInfo.failCities);
    this.updateDccSearchStatus()
    this.retrieveMembers();
  },
  mounted() {
    // this.retrieveCarOptions();
    setTimeout(() => {
      this.retrieveSeriesOptions();
      this.getCompetitionSeriesesOptions();
      this.getProvinces();
    }, 1000);
  },
  methods: {
    ...mapActions('user', ['setDccTip']),
    // 判断二级来源是否需要高亮
    isHighlightSecondSource(secondSource) {
      if (!secondSource || !this.siteDescHighLights.length) return false
      return this.siteDescHighLights.some(item => item.dataValue == 1 && item.dataName === secondSource)
    },
    tableRowClassName({ row }) {
      return row.highlightRow ? 'highlight-row' : '';
    },
    handleUploadSuccess(response, file, fileList) {
      console.log('Upload successful:', response);
    },
    handleUploadError(error, file, fileList) {
      console.error('Upload error:', error);
    },
    transformatLabel(val, list) {
      return list.find(item => item.dataValue === val)?.dataDisplay ?? ''
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
          this.dealerProvince = res.data.province;
          this.dealerCity = res.data.city;
          this.dealerArea = res.data.county;
        }).catch(error => {
          console.error('获取省份失败:', error);
        });
    },
    // 获取市
    getCityList(provinceName) {
      return new Promise((resolve,reject)=> {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: provinceName,
          city: "",
        })
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取区
    getAreaList(params) {
      return new Promise((resolve,reject) => {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", params)
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 改变购车地区省
    changeBuyCarProvince(provinceName) {
      this.form.buyCity = "";
      this.form.buyArea = "";
      this.buyCarCityList = [] // 清除市列表
      this.buyCarAreaList = [] // 清除区列表
      if (provinceName) {
        this.getCityList(provinceName).then(res => {
          this.buyCarCityList = res.data.data;
        })
        this.form.buyCarAddress = [provinceName]// 重置选择项
        this.detailForm.buyCarAddressText = this.getBuyCarAddressText(this.form.buyCarAddress)
      } else {
        this.form.buyProvince = "";
        this.form.buyCarAddress = []// 重置选择项
        this.detailForm.buyCarAddressText = ''
      }
    },
    // 改变购车城市
    changeBuyCarCity(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.form.buyProvince,
        city:cityName
      }
      this.buyCarAreaList = []// 清除区列表
      this.form.buyArea = "";// 清除区
      // 选择区域
      if (cityName) {
        // 获取区域
        this.getAreaList(params).then(res => {
          this.buyCarAreaList = res.data.data;
        })
        this.form.buyCarAddress = [this.form.buyCarAddress[0],cityName]// 重置选择项
      } else {
        // 清空市
        this.form.buyCity = "";// 清除市
        this.form.buyCarAddress = [this.form.buyCarAddress[0]]// 重置选择项
      }
      this.detailForm.buyCarAddressText = this.getBuyCarAddressText(this.form.buyCarAddress)
    },
    // 改变购车地区区域
    changeBuyCarArea(areaName) {
      if (areaName) {
        this.form.buyCarAddress =[this.form.buyCarAddress[0], this.form.buyCarAddress[1],areaName]// 重置选择项
      } else {
        this.form.buyArea = "";
        this.form.buyCarAddress =[this.form.buyCarAddress[0], this.form.buyCarAddress[1]]// 重置选择项
      }
      this.detailForm.buyCarAddressText = this.getBuyCarAddressText(this.form.buyCarAddress)
      this.$forceUpdate()
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        }).catch(error => {
          console.error('获取车型失败:', error);
        });
    },
    getProvinceOptions(data) {
      let result = [];
      let provinces = {};
      for (let i = 0; i < data.length; i++) {
        let city = data[i];
        if (!provinces[city.province]) {
          let province = { label: city.province };
          result.push(province);
          provinces[city.province] = [];
        }
        provinces[city.province].push({ label: city.city });
      }
      for (let i = 0; i < result.length; i++) {
        let province = result[i];
        province.children = provinces[province.label];
      }
      return result;
    },
    MillisecondToDate(val) {
      return MillisecondToDate(val);
    },
    getCompetitionSeriesesOptions() {
      var that = this;
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: that.dealer.dealerId,
          key: "",
        })
        .then(function (response) {
          that.competitionSeriesesOptions = response.data.data;
        }).catch(error => {
          console.error('获取竟态车型失败:', error);
        });
    },
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.members = response.data.data;
          if (!parent.isAdmin) {
            parent.members.push({
              memberId: parent.dealer.userId,
              userName: parent.dealer.name,
            });
          }
        }).catch(error => {
          console.error('获取成员失败:', error);
        });
    },
    retrieveAssignMembers() {
      var parent = this;
      this.$httpAuth
        .post("v2/appDealerManagerService/assignMembers", {
          dealerId: this.dealer.dealerId,
          isAll: true,
        })
        .then(function (response) {
          parent.assignMembers = response.data.data;
        }).catch(error => {
          console.error('获取分配成员失败:', error);
        });
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        }).catch(error => {
          console.error('获取车型失败:', error);
        });
    },
    retrieveTables1() {
      if (this.filterType == 3 || this.filterType == 4 || this.filterType == 8) {
        this.searchQuery.dateRange = [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 29).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ];
      } else if (this.filterType == 6) {
        this.searchQuery.dateRange = [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6).Format(
            "yyyy-MM-dd"
          ),
          new Date().Format("yyyy-MM-dd"),
        ];
      } else {
        this.searchQuery.dateRange = null;
      }
      // 未接通不增加“是否微信线索”筛选条件 并重置该筛选项
      if(this.filterType == 5) {
        this.searchQuery.isWechatClue = 0
      }
      this.searchQuery.clearDateRange = null;
      this.searchQuery.clearTime = "";
      this.updateDccSearchStatus()
      this.listQuery.page = 1;
      this.getList();
    },
    // dcc搜索状态
    updateDccSearchStatus() {
      // 线索列表dcc筛选项  
      // 待清洗 + 未接通 + 无效 --  直营门店/社会经销商非DCC门店 不展示
      // 待分配 + 有效  -- 所有门店 展示
      let flag = false
      if(activityTypeDCCList.includes(this.filterType)) {
        flag = (this.profile.dealerType === 1 || this.profile.isDccDealer === 0)
      }
      // if(activityTypeList.includes(this.filterType)) {
      //   flag = false
      // }
      // this.searchQuery.isDccClue = !flag ? isDccClueList[0].value : isDccClueList[2].value
      this.displayDccSearch = !flag
      this.searchQuery.isDccClue = this.getDefaultIsDccClue()
    },
    // 是否DCC线索默认值：不展示筛选时固定为"否"；展示时，待清洗tab默认"否"，其他tab默认"全部"
    getDefaultIsDccClue() {
      if (!this.displayDccSearch) return isDccClueList[2].value
      return this.filterType == 1 ? isDccClueList[2].value : isDccClueList[0].value
    },
    retrieveTables() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.retrieveAssignMembers();
      var parent = this;
      if(this.filterType == 6) {

        // console.log(!this.searchQuery.dateRange || !this.searchQuery.dateRange.length, this.searchQuery.clearTime, this.searchQuery.dateRange, this.searchQuery.dateRange.length , !this.searchQuery.clearTime, '0000')
        if(
          ((!this.searchQuery.clearDateRange || !this.searchQuery.clearDateRange.length) && this.searchQuery.clearTime) ||
          (this.searchQuery.clearDateRange && this.searchQuery.clearDateRange.length && !this.searchQuery.clearTime)
        ) {
          this.$message.warning("根据线索清洗开始时间筛选或导出时，必须同时设置日期范围和时间段")
          return
        }
      }
      this.listLoading = true;
      const params = this.getParams();
      const url = this.filterType !== 8 ? '/v2/appClueService/list' : '/v2/appClueService/highIntentionList'
      return this.$httpAuth
        .post(url, params)
        .then(function (response) {
          parent.listLoading = false;
          if(!response.data || !response.data.data) {
            return;
          }
          parent.tableRecords = (response.data.data || []).map(row => ({
            ...row,
            highlightRow: parent.filterType === 1 && parent.isHighlightSecondSource(row.secondSource)
          }));
          parent.total = response.data.total;
        }).catch(error => {
          parent.listLoading = false;
          console.error('获取线索列表失败:', error);
        });
    },
    getParams(isExport) {
      const [clearHourstart, clearHourend] = this.searchQuery.clearTime.split('-')
      let params = {
          isExport,
          dealerId: this.dealer.dealerId,
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          
          onlineSources: this.searchQuery.onlineSources.join(","),
          entry: this.searchQuery.entry.toString(),
          clueSource: this.searchQuery.clueSource, // 线索来源
          secondSource: this.searchQuery.secondSource, //线索二级来源
          userIds: this.searchQuery.member.join(","),
          key: this.searchQuery.key,
          clueLevel: this.searchQuery.clueLevel,
          isRemote: this.searchQuery.isRemote,
          isWechatClue: this.searchQuery.isWechatClue,
          createdDate: {
            start:
              this.searchQuery.dateRange != null
                ? this.searchQuery.dateRange[0]
                : "",
            end:
              this.searchQuery.dateRange != null
                ? this.searchQuery.dateRange[1]
                : "",
          },
          clearTimeStart: this.searchQuery.clearDateRange != null ? dayjs(`${this.searchQuery.clearDateRange[0]} 00:00:00`).unix()  : null,
          clearTimeEnd: this.searchQuery.clearDateRange != null ? dayjs(`${this.searchQuery.clearDateRange[1]} 23:59:59`).unix() : null,
          
          clearHourstart: Number(clearHourstart) || null,
          clearHourend: Number(clearHourend) || null
        }
        if(this.filterType !== 8) {
          params.activityType = this.filterType;
          params.isDccClue = this.searchQuery.isDccClue;
        }
        return params;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    reset() {
      this.searchQuery = {
        key: "",
        onlineSources: [],
        entry: [],
        clueSource: '', // 线索来源
        secondSource: '', //线索二级来源
        clueLevel: 0,
        dateRange: null,
        clearDateRange: null,
        clearTime: "",
        member: [],
        isRemote: null,
        isWechatClue: 0,
        // isDccClue: this.displayDccSearch ? isDccClueList[0].value : isDccClueList[2].value,
        isDccClue: this.getDefaultIsDccClue(),
      };
      this.retrieveTables();
      this.confirmLoading = false;
    },
    changeLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.form.level) {
          days = o.dataValue;
          break;
        }
      }
      this.form.nextDate = this.$common.addDate(new Date(), days);
    },
    getBuyCarAddressText(arr) {
      if (!arr || !arr.length) return ''
      return arr.filter(item=> !!item).join('/')
    },
    toDetailPage({clueId: id, customerId }) {
      // 高意向跳转客户详情页
      if(this.filterType === 8 && customerId) {
        const listFilters = {
          searchQuery: this.searchQuery,
          filterType: this.filterType,
          total: this.total,
          listQuery: this.listQuery,
        };
        sessionStorage.setItem("listFilters", JSON.stringify(listFilters));
        this.$router.push({
          path: "/customer/detail/" + customerId,
        });
        return
      }
      
      // 清空所在地
      this.home = [];
      this.form = {
        type: 1,
        memberType: 1,
        invalidReason: "",
        companyName: "",
        fromSource: "",
        secondardPhone: "",
        businessType: 1,
        buyCarAddress: [],
        gender: "",
        budget: 1,
        buyCount: 0,
        buycarDate: "",
        specIds: [],
        competitionSerieses: [],
        memberId: "",
        remark: "",
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        addition: {
          province: "",
          city: "",
          address: "",
          idNo: "",
          birthday: "",
          qq: "",
        },
        home: [],
        wxPic: []
      };
      this.confirmLoading = false;
      this.changeLevel();
      this.$httpAuth
        .post("/v2/appClueService/detail", {
          dealerId: this.dealer.dealerId,
          clueId: id,
        })
        .then(response =>{
          const data = response.data.data || {};// 线索详情信息
          this.detailForm = data;
          this.detailForm.activityDesc = [data.clueSource, data.siteDesc].filter(e => !!e).join('-')
          if (this.detailForm.historySpec == "") {
            this.detailForm.historySpec = "{}";
          }
          if (this.detailForm.attentionSeries == "") {
            this.detailForm.attentionSeries = "{}";
          }
          if (this.detailForm.mappingSpecId == 0) {
            this.form.specIds = [];
            this.form.nextTestSpecId = "";
          } else {
            this.form.specIds.push(this.detailForm.mappingSpecId);
            this.form.nextTestSpecId = this.detailForm.mappingSpecId;
          }
          let province = '',city='';
          if (data.buyProvince&&data.buyCity) {
            // 初始化 购车地区
            const arr = [data.buyProvince,data.buyCity,data.buyArea]
            this.form.buyCarAddress = arr;
            this.form.buyProvince = arr[0];
            this.form.buyCity = arr[1];
            this.form.buyArea = arr[2];
            this.detailForm.buyCarAddressText = this.getBuyCarAddressText(arr)
            province = data.buyProvince;
            city = data.buyArea;
          } else if (this.dealerProvince) {
            const arr = [this.dealerProvince, this.dealerCity,this.dealerArea]
            this.form.buyCarAddress = arr;
            this.form.buyProvince = arr[0];
            this.form.buyCity = arr[1];
            this.form.buyArea = arr[2];
            this.detailForm.buyCarAddressText = this.getBuyCarAddressText(arr)
            province = arr[0];
            city = arr[1];
          } else {
            this.form.buyCarAddress = []
            this.form.buyProvince = '';
            this.form.buyCity = '';
            this.form.buyArea = '';
            this.detailForm.buyCarAddressText = ''
          }
          // 操作记录
          this.timelines = response.data.timeline?.map(item => {
            let invalidReasonText = ''
            if (item.invalidReason !== 0) {
              invalidReasonText = this.clueInvalidReasons?.find((e) => e.dataValue == item.invalidReason)?.dataDisplay ?? ''
            }
            const remark = item.remark

            const remarkPic = this.transformWxPic(remark)

            return {
              ...item,
              invalidReasonText,
              remark: this.transformRemark(remark),
              remarkPic
            }
          })
          if (this.detailForm.status == 12) {
            this.form.type = 3;
          }
          // 1：待清洗 4:无效  12：未接通
          if (
            this.detailForm.status != 1 &&
            this.detailForm.status != 5 &&
            this.detailForm.status != 12
          ) {
            this.formViewOnly = true;
            //  4：下发后无效线索
            if (this.detailForm.status == 4) {
              this.formViewOnly = false;
            }
          } else {
            this.formViewOnly = false;
          }
          this.detailDialog = true;
          // this.$nextTick(()=> {
          //   this.$refs.form.clearValidate();
          // })
          this.buyCarCityList = [] // 清除市列表
          this.buyCarAreaList = [] // 清除区列表
          this.form.wxPic = []
          this.$nextTick(()=> {
            this.$refs["form"] && this.$refs["form"].clearValidate()
          })
          if (province) {
            this.getCityList(province).then(res => {
              this.buyCarCityList = res.data.data;
            })
          }
          if (province&&city) {
            this.getAreaList({
              dealerId: this.dealer.dealerId,
              province: province,
              city: city
            }).then(res => {
              this.buyCarAreaList = res.data.data;
            })
          }
        });
    },
    transformRemark(remark) {
      const separator = "客户微信截图:";
      const parts = remark.split(separator);
      return parts[0]
    },
    transformWxPic(remark) {
      const separator = "客户微信截图: ";
      const parts = remark.split(separator);
      const result = parts[1] ? parts[1].split(',') : []
      return result
    },
    showTagDialog(id) {
      var parent = this;
      this.confirmLoading = false;
      this.$httpAuth
        .post("/v1/customerRpc/getOnlineCustomer", {
          dealerId: this.dealer.dealerId,
          onlineCustomerId: id,
        })
        .then(function (response) {
          parent.detailForm = response.data.data;
          if (parent.detailForm.historySpec == "") {
            parent.detailForm.historySpec = "{}";
          }
          if (parent.detailForm.attentionSeries == "") {
            parent.detailForm.attentionSeries = "{}";
          }
          parent.introDialog = true;
        });
    },
    doConfirm() {
      if (this.isWxClue && this.detailForm.phone) {
        if(!mobileReg.test(this.detailForm.phone)){
          this.$message({
            message: "手机号输入格式不正确",
            type: "warning",
          });
          return;
        }
        // 无效线索
        if (this.form.type == 2 && this.form.invalidReason == "") {
          this.$message({
            message: "请选择无效原因",
            type: "warning",
          });
          return;
        }
        // 有效线索
        if (this.form.type == 1) {
          if (!(this.form.buyProvince&&this.form.buyCity)) {
            this.$message({
              message: "请选择购车地区",
              type: "warning",
            });
            return;
          }
          if (this.form.specIds.length == 0) {
            this.$message({
              message: "请选择意向车系",
              type: "warning",
            });
            return;
          }
          if (this.allowAssign && this.form.memberId == "") {
            this.$message({
              message: "请选择客户经理",
              type: "warning",
            });
            return;
          }
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$httpAuth
              .post("/v2/appClueService/checkExist", {
                dealerId: this.dealer.dealerId,
                phone: this.detailForm.phone,
              })
              .then((res) => {
                const { isExisted, data } = res.data;
                if (isExisted) {
                  this.mergeVisible = true;
                  this.mergeCustomerInfo = data;
                } else {
                  this.doNormalConfirm()
                }
              })
              .catch(() => {
              });
          }
        });
      } else {
        this.doNormalConfirm()
      }
    },
    doNormalConfirm() {
      var parent = this;
      if (this.form.type == 2) {
        console.log('---【form.type == 2】无效页面-----')
        if (this.form.invalidReason == "") {
          this.$message({
            message: "请选择无效原因",
            type: "warning",
          });
          return;
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const currentDate = new Date()
            const currentTimestampInSeconds = Math.floor(currentDate.getTime() / 1000)
            let msg = '此操作将该线索设为无效, 是否继续？'
            if(!this.isWxClue) { 
              if (!this.detailForm.dialTime) {
                msg = '未检测到和客户有通话记录行为，确认提交吗？'
              } else if (this.calculateTimeDifference(this.detailForm.dialTime, currentTimestampInSeconds) <= 15 || this.detailForm.dialDuration <= 15) {
                msg = '检测到您通话时长过短，确认提交吗？'
              }              
            }

            this.$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                parent.confirmLoading = true;
                parent.$httpAuth
                  .post("/v2/appClueService/clear", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    isValid: false,
                    invalidReason: parent.form.invalidReason,
                    remark: parent.form.remark,
                    invalidProvince: parent.form.home[0],
                    invalidCity: parent.form.home[1],
                    wechatPicUrl: getUrls(parent.form.wxPic).join(','),
                    mobile: this.detailForm.phone
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        });

        return;
      }

      if (this.form.type == 3) {
        console.log('---【form.type == 3】未接通页面-----')
        const currentDate = new Date()
        const currentTimestampInSeconds = Math.floor(currentDate.getTime() / 1000)
        let msg = '是否继续？'
        if(!this.isWxClue) { 
          if (!this.detailForm.dialTime) {
            msg = '未检测到和客户有通话记录行为，确认提交吗？'
          } else if (this.calculateTimeDifference(this.detailForm.dialTime, currentTimestampInSeconds) <= 15 || this.detailForm.dialDuration <= 15) {
            msg = '检测到您通话时长过短，确认提交吗？'
          }
        }

        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            parent.confirmLoading = true;
            parent.$httpAuth
              .post("/v2/appClueService/noContact", {
                dealerId: parent.dealer.dealerId,
                clueId: parent.detailForm.id,
              })
              .then(function () {
                parent.$message({
                  type: "success",
                  message: "操作成功!",
                });
                parent.mergeVisible = false
                parent.detailDialog = false;
                parent.confirmLoading = false;
                parent.getList();
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          })
          .catch(() => {
            parent.confirmLoading = false;
          });
        return;
      }

      if (this.detailForm.status == 1 && this.isAutoClear) {
        console.log('---【status == 1】待清洗且无BDC清洗，自动分配-----')
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (
              this.form.nextActivityType == 3 &&
              this.form.nextTestSpecId == ""
            ) {
              this.$message({
                message: "请选择试驾车系",
                type: "warning",
              });
              return;
            }
            this.$confirm("是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                if (parent.home.length !== 0) {
                  parent.form.addition.province = parent.home[0];
                  parent.form.addition.city = parent.home[1];
                }
                parent.confirmLoading = true;
                const [buyProvince, buyCity, buyArea=''] = this.form.buyCarAddress
                parent.$httpAuth
                  .post("/v2/appClueService/clear", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    isValid: true,
                    name: parent.detailForm.name,
                    mobile: parent.detailForm.phone,
                    weixin: parent.detailForm.wechatId,
                    type: parent.form.memberType,
                    companyName: parent.form.companyName,
                    fromSource: 0,
                    otherSource: parent.form.otherSource,
                    addition: {
                      province: parent.form.addition.province,
                      city: parent.form.addition.city,
                      address: parent.form.addition.address,
                      idNo: parent.form.addition.idNo,
                      birthday: this.form.addition.birthday,
                      qq: parent.form.addition.qq,
                      identifyType: 1,
                    },
                    specIds: parent.form.specIds.join(","),
                    competitionSerieses: parent.form.competitionSerieses.join(
                      ","
                    ),
                    memberId: 0,
                    businessType: parent.form.businessType,
                    buyProvince,
                    buyCity,
                    buyArea,
                    gender: parent.form.gender,
                    budget: parent.form.budget,
                    buyCount: parent.form.buyCount,
                    buycarDate:
                      parent.form.buycarDate !== ""
                        ? parseInt(parent.form.buycarDate.getTime() / 1000)
                        : 0,
                    level: parent.form.level,
                    nextActivityType: parent.form.nextActivityType,
                    nextDate: parseInt(parent.form.nextDate.getTime() / 1000),
                    nextTestSpecId: +parent.form.nextTestSpecId,
                    // invalidReason: parent.form.invalidReason,
                    remark: parent.form.remark,
                    wechatPicUrl: getUrls(parent.form.wxPic).join(',')
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        });

        return;
      }
      if (this.detailForm.status == 12 && this.isAutoClear) {
        console.log('---【status == 5】未接通且无BDC清洗，自动分配（-----')
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (
              this.form.nextActivityType == 3 &&
              this.form.nextTestSpecId == ""
            ) {
              this.$message({
                message: "请选择试驾车系",
                type: "warning",
              });
              return;
            }
            this.$confirm("是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                if (parent.home.length !== 0) {
                  parent.form.addition.province = parent.home[0];
                  parent.form.addition.city = parent.home[1];
                }
                const [buyProvince, buyCity, buyArea] = this.form.buyCarAddress
                parent.confirmLoading = true;
                parent.$httpAuth
                  .post("/v2/appClueService/clear", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    isValid: true,
                    name: parent.detailForm.name,
                    mobile: parent.detailForm.phone,
                    weixin: parent.detailForm.wechatId,
                    type: parent.form.memberType,
                    companyName: parent.form.companyName,
                    fromSource: 0,
                    otherSource: parent.form.otherSource,
                    addition: {
                      province: parent.form.addition.province,
                      city: parent.form.addition.city,
                      address: parent.form.addition.address,
                      idNo: parent.form.addition.idNo,
                      birthday: this.form.addition.birthday,
                      qq: parent.form.addition.qq,
                      identifyType: 1,
                    },
                    specIds: parent.form.specIds.join(","),
                    competitionSerieses: parent.form.competitionSerieses.join(
                      ","
                    ),
                    memberId: 0,
                    businessType: parent.form.businessType,
                    buyProvince,
                    buyCity,
                    buyArea,
                    gender: parent.form.gender,
                    budget: parent.form.budget,
                    buyCount: parent.form.buyCount,
                    buycarDate:
                      parent.form.buycarDate !== ""
                        ? parseInt(parent.form.buycarDate.getTime() / 1000)
                        : 0,
                    level: parent.form.level,
                    nextActivityType: parent.form.nextActivityType,
                    nextDate: parseInt(parent.form.nextDate.getTime() / 1000),
                    nextTestSpecId: +parent.form.nextTestSpecId,
                    // invalidReason: parent.form.invalidReason,
                    remark: parent.form.remark,
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        });

        return;
      }
      if (this.detailForm.status == 4 && this.isAutoClear) {
        console.log('---【status == 4】无效线索且无BDC清洗，自动分配（-----')
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (
              this.form.nextActivityType == 3 &&
              this.form.nextTestSpecId == ""
            ) {
              this.$message({
                message: "请选择试驾车系",
                type: "warning",
              });
              return;
            }
            this.$confirm("是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                if (parent.home.length !== 0) {
                  parent.form.addition.province = parent.home[0];
                  parent.form.addition.city = parent.home[1];
                }
                parent.confirmLoading = true;
                const [buyProvince, buyCity, buyArea] = this.form.buyCarAddress
                parent.$httpAuth
                  .post("/v2/appClueService/clear", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    isValid: true,
                    name: parent.detailForm.name,
                    mobile: parent.detailForm.phone,
                    weixin: parent.detailForm.wechatId,
                    type: parent.form.memberType,
                    companyName: parent.form.companyName,
                    fromSource: 0,
                    otherSource: parent.form.otherSource,
                    addition: {
                      province: parent.form.addition.province,
                      city: parent.form.addition.city,
                      address: parent.form.addition.address,
                      idNo: parent.form.addition.idNo,
                      birthday: this.form.addition.birthday,
                      qq: parent.form.addition.qq,
                      identifyType: 1,
                    },
                    specIds: parent.form.specIds.join(","),
                    competitionSerieses: parent.form.competitionSerieses.join(
                      ","
                    ),
                    memberId: 0,
                    businessType: parent.form.businessType,
                    buyProvince,
                    buyCity,
                    buyArea,
                    gender: parent.form.gender,
                    budget: parent.form.budget,
                    buyCount: parent.form.buyCount,
                    buycarDate:
                      parent.form.buycarDate !== ""
                        ? parseInt(parent.form.buycarDate.getTime() / 1000)
                        : 0,
                    level: parent.form.level,
                    nextActivityType: parent.form.nextActivityType,
                    nextDate: parseInt(parent.form.nextDate.getTime() / 1000),
                    nextTestSpecId: +parent.form.nextTestSpecId,
                    // invalidReason: parent.form.invalidReason,
                    remark: parent.form.remark,
                    wechatPicUrl: getUrls(parent.form.wxPic).join(',')
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        });

        return;
      }
      if (this.detailForm.status == 5) {
        console.log('---【status == 5】待分配线索-----')
        if (this.form.memberId == "" && this.allowAssign) {
          this.$message({
            message: "请选择客户经理",
            type: "warning",
          });
          return;
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$confirm("是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                parent.confirmLoading = true;
                parent.$httpAuth
                  .post("/v2/appClueService/assign", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    memberId: +parent.form.memberId,
                    remark: parent.form.remark,
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        })
        return;
      }
      if (this.form.type == 1) {
        console.log('---form.type == 1】有效页面-----')
        if (!(this.form.buyProvince&&this.form.buyCity)) {
          this.$message({
            message: "请选择购车地区",
            type: "warning",
          });
          return;
        }
        if (this.form.specIds.length == 0) {
          this.$message({
            message: "请选择意向车系",
            type: "warning",
          });
          return;
        }
        if (this.allowAssign && this.form.memberId == "") {
          this.$message({
            message: "请选择客户经理",
            type: "warning",
          });
          return;
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const currentDate = new Date()
            const currentTimestampInSeconds = Math.floor(currentDate.getTime() / 1000)
            let msg = '是否继续？'
            if(!this.isWxClue) {
              if (!this.detailForm.dialTime) {
                msg = '未检测到和客户有通话记录行为，确认提交吗？'
              } else if (this.calculateTimeDifference(this.detailForm.dialTime, currentTimestampInSeconds) <= 15 || this.detailForm.dialDuration <= 15) {
                msg = '检测到您通话时长过短，确认提交吗？'
              }
            }

            this.$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                parent.confirmLoading = true;
                const [buyProvince, buyCity, buyArea] = this.form.buyCarAddress
                parent.$httpAuth
                  .post("/v2/appClueService/clear", {
                    dealerId: parent.dealer.dealerId,
                    clueId: parent.detailForm.id,
                    isValid: true,
                    gender: 1,
                    type: 1,
                    level: "N",
                    companyName: "",
                    fromSource: 0,
                    otherSource: "",
                    name: parent.detailForm.name,
                    mobile: parent.detailForm.phone,
                    weixin: parent.detailForm.wechatId,
                    secondardPhone: "",
                    addition: {
                      province: parent.form.addition.province,
                      city: parent.form.addition.city,
                      address:
                        parent.detailForm.province + "/" + parent.detailForm.city,
                      idNo: "",
                      birthday: "",
                      qq: "",
                      identifyType: 1,
                    },
                    budget: 1,
                    // businessType: 1,
                    tags: "",
                    nextActivityType: 1,
                    nextDate: parseInt(new Date().getTime() / 1000),
                    buycarDate: parseInt(new Date().getTime() / 1000),
                    nextTestSpecId:
                      parent.form.specIds.length > 0
                        ? parent.form.specIds[0]
                        : 1208,
                    buyCount: parent.form.buyCount,
                    specIds: parent.form.specIds.join(","),
                    competitionSerieses: parent.form.competitionSerieses.join(","),
                    memberId: this.allowAssign ? +parent.form.memberId : 0,
                    businessType: parent.form.businessType,
                    buyProvince,
                    buyCity, 
                    buyArea,
                    // invalidReason: parent.form.invalidReason,
                    remark: parent.form.remark,
                    wechatPicUrl: getUrls(parent.form.wxPic).join(',')
                  })
                  .then(function () {
                    parent.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                    parent.mergeVisible = false
                    parent.detailDialog = false;
                    parent.confirmLoading = false;
                    parent.getList();
                  })
                  .catch(() => {
                    parent.confirmLoading = false;
                  });
              })
              .catch(() => {
                parent.confirmLoading = false;
              });
          }
        })
      }
    },
    doCancel() {
      this.detailDialog = false
    },
    handleMerge(isMerge) {
      if(isMerge) {
        const wechatPicUrl = getUrls(this.form.wxPic).join(',')
        const params = {
          dealerId: this.dealer.dealerId, //经销商id	
          clueId: this.detailForm.id, // 线索id	
          customerId: this.mergeCustomerInfo.customerId, //客户id	
          phone: this.mergeCustomerInfo.phone, //手机号	
          wechatId: this.detailForm.wechatId,  //微信号	
          wechatPicUrl,  // 客户微信截图
          remark: this.form.remark, // 备注
        }
        this.$httpAuth
          .post('/v2/appClueService/mergeCustomer', params)
          .then((response)=> {
            if(response.data.success) {
              this.$message.success('合并原客档成功')
              this.mergeVisible = false
              this.confirmLoading = false;
              this.detailDialog = false;
              this.getList();
            } else {
              this.message.error(response.message || '合并原客档失败')
            }
          })
          .catch((e) => {
            console.log(e, 'error')
          });
      } else {
        // 有效清空手机号
        if(this.form.type == 1) {
          this.detailForm.phone = ''
        } 
        this.doNormalConfirm();
      }
    },
    doExport() {
      if(this.filterType == 6) {
        if(
          ((!this.searchQuery.clearDateRange || !this.searchQuery.clearDateRange.length) && this.searchQuery.clearTime) ||
          (this.searchQuery.clearDateRange && this.searchQuery.clearDateRange.length && !this.searchQuery.clearTime)
         ) {
          this.$message.warning("根据线索清洗开始时间筛选或导出时，必须同时设置日期范围和时间段")
          return
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const params = this.getParams(true);
      const url = this.filterType !== 8 ? '/v2/appClueService/list' : '/v2/appClueService/highIntentionList'
      this.$httpAuth
        .post(url, params)
        .then((response)=> {
          const { file, total, filterHours } = response.data
          if (total > 2000) {
            this.$message({
              customClass: 'export-message',
              dangerouslyUseHTMLString: true,
              message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
              duration: 2000
            });
          }
          if (filterHours) {
            setTimeout(() => {
              this.$message({
                customClass: 'export-message',
                dangerouslyUseHTMLString: true,
                message: `<div>厂端已禁止导出最近${filterHours}小时内流入的线索（导出表已剔除相应线索）</div>`,
                duration: 2000
              });
            }, 100);
          }
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
    closeDccTip() {
      this.setDccTip({[this.dealer.userId]: true})
    },
    /**
     * 提示条"查看全部"：切换是否DCC线索筛选为"全部"并重新搜索
     * 搜索返回后关闭提示条（复用 closeDccTip 的持久化逻辑）
     */
    viewDccClueAll() {
      // 边界1：isDccClueList 空数组时取值报错，直接关闭提示兜底
      if (!isDccClueList || !isDccClueList.length) {
        // this.closeDccTip();
        return;
      }
      this.searchQuery.isDccClue = isDccClueList[0].value;
      // 边界2：搜索请求返回（成功或异常）后关闭提示条，与 closeDccTip 效果一致
      const request = this.getList();
      if (request && typeof request.finally === 'function') {
        request.finally(() => this.closeDccTip());
      } else {
        // 边界3：getList 提前 return（如校验未过）返回 undefined，直接关闭提示
        // this.closeDccTip();
      }
    },
    // 两个秒级时间戳相差的毫秒数
    calculateTimeDifference(timestamp1, timestamp2) {
      return Math.abs(timestamp2 - timestamp1)
    }
  },
};
</script>

<style scoped>
.add-title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 10px;
  margin-top: 10px;
}

.el-loading-mask {
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.5);
}

.el-pagination .more+.number {
  display: none !important;
}

.form_item--buyAddress /deep/.el-form-item__label{
  padding: 0;
}

.filter-container:has(+ .dcc-tip) {
  padding-bottom: 0px !important;
}

.filter-tab {
  margin-bottom: 10px;
}

::v-deep .highlight-row > td {
  background-color: #fff3cd !important;
}

.filter-container:has(+ .dcc-tip) .filter-tab {
  margin-bottom: 0px !important;
}

.dcc-tip {
  margin-top: 20px;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  width: 414px;
  height: 30px;
  line-height: 30px;
  background: rgb(231, 244, 255);
}
.dcc-tip .el-icon-close {
  cursor: pointer;
  font-size: 16px;
}
</style>
<style>
/* .export-message {
  z-index: 2600 !important;
} */
.export-message .el-icon-info, .el-message__content{
  color: #F56C6C !important; 
}
</style>
